import React from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { useTranslation } from "react-i18next"
import VideosTable from "./VideosTable"

export default function VideosList() {
  const { t } = useTranslation()
  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs title="" breadcrumbItem={t("pages.Videos")} />
        <VideosTable />
      </div>
    </div>
  )
}
